<template>
    <rkm-form
        v-if="model"
        ref="RkmForm"
        show-legend
    >
        <rkm-row>
            <rkm-col>
                <rkm-form-input
                    :validations="validations.nome"
                    label="Nome"
                    uppercase
                    v-model="model.nome"
                />
            </rkm-col>

            <rkm-col cols="2">
                <rkm-form-input
                    :validations="validations.cnes"
                    label="CNES"
                    number
                    v-model="model.cnes"
                />
            </rkm-col>

            <rkm-col cols="auto">
                <rkm-form-checkbox
                    :label="false"
                    inline
                    v-model="model.isAlmoxarifado"
                >
                    Almoxarifado
                </rkm-form-checkbox>
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="12">
                <rkm-area
                    title="Centro de custo (ConectaSUS)"
                    type="fieldset"
                >
                    <rkm-row>
                        <rkm-col cols="4">
                            <rkm-form-select
                                :options="form.conectasusUnidades"
                                @change="loadInfraestruturas"
                                label="Unidade"
                                show-default-option
                                text-field="nomeFantasia"
                                v-model="model.conectasusUnidadeId"
                                value-field="id"
                            />
                        </rkm-col>

                        <rkm-col cols="4">
                            <rkm-form-select
                                :disabled="!model.conectasusUnidadeId"
                                :options="form.conectasusInfraestruturas"
                                :validations="validations.conectasusInfraestrutura"
                                @change="loadCentrosCusto"
                                label="Local de atendimento"
                                show-default-option
                                text-field="nome"
                                v-model="model.conectasusInfraestruturaId"
                                value-field="id"
                            />
                        </rkm-col>

                        <rkm-col cols="4">
                            <rkm-form-select
                                :disabled="!model.conectasusInfraestruturaId"
                                :options="form.conectasusCentrosCusto"
                                :validations="validations.conectasusCentroCusto"
                                label="Setor"
                                show-default-option
                                text-field="setorNome"
                                v-model="model.conectasusCentroCustoId"
                                value-field="id"
                            />
                        </rkm-col>
                    </rkm-row>
                </rkm-area>
            </rkm-col>
        </rkm-row>
    </rkm-form>
</template>

<script>
// Mixins.
import {error, repository, stringCase} from '@/mixins'

// Vuex.
import {mapActions} from 'vuex'

export default {
    computed: {
        validations() {
            return {
                nome: {
                    required: true,
                    min: 3,
                    max: 100,
                },
                cnes: {
                    min: 7,
                    max: 7,
                },
                conectasusInfraestrutura: {required: !!this.model.conectasusUnidadeId},
                conectasusCentroCusto: {required: !!this.model.conectasusInfraestruturaId},
            }
        },
    },
    created() {
        this.repositories = {
            unidade: this.getConectaSusRepository('webService.almoxarifado.cliente.unidade'),
        }
    },
    data: () => ({
        form: null,
        model: null,
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {
            this.setLoading()

            if (this.id) {
                this.repositories.unidade.edit(this.id)
                    .then(response => {
                        this.form = Object.assign(response.data.form)
                        this.model = Object.assign(response.data.model)
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            } else {
                this.repositories.unidade.create()
                    .then(response => {
                        this.form = Object.assign(response.data.form)
                        this.model = Object.assign(response.data.model)
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }
        },
        loadInfraestruturas() {
            this.form.conectasusInfraestruturas = []
            this.model.conectasusInfraestruturaId = null
            this.form.conectasusCentrosCusto = []
            this.model.conectasusCentroCustoId = null

            if (!this.model.conectasusUnidadeId) return

            this.setLoading()

            this.repositories.unidade.list(this.camelObjectKeysToSnakeRecursive({
                listar: 'infraestruturas',
                unidadeId: this.model.conectasusUnidadeId,
            }))
                .then(response => {
                    this.form.conectasusInfraestruturas = Object.assign(response.data)

                    if (this.form.conectasusInfraestruturas.length === 1){
                        this.model.conectasusInfraestruturaId = this.form.conectasusInfraestruturas[0].id

                        this.loadCentrosCusto()
                    }
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        loadCentrosCusto() {
            this.form.conectasusCentrosCusto = []
            this.model.conectasusCentroCustoId = null

            if (!this.model.conectasusInfraestruturaId) return

            this.setLoading()

            this.repositories.unidade.list(this.camelObjectKeysToSnakeRecursive({
                listar: 'centros-custo',
                infraestruturaId: this.model.conectasusInfraestruturaId,
            }))
                .then(response => {
                    this.form.conectasusCentrosCusto = Object.assign(response.data)

                    if (this.form.conectasusCentrosCusto.length === 1){
                        this.model.conectasusCentroCustoId = this.form.conectasusCentrosCusto[0].id
                    }
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        save() {
            this.$refs.RkmForm.validate()
                .then(valid => {
                    if (valid === false) return

                    this.setLoading()

                    if (this.id) {
                        this.repositories.unidade.update(this.id, this.camelObjectKeysToSnakeRecursive(this.model))
                            .then(response => {
                                this.showSaveNotification()
                                this.$emit('saved', response)
                            })
                            .catch(this.handleError)
                            .finally(() => this.unsetLoading())
                    } else {
                        this.repositories.unidade.store(this.camelObjectKeysToSnakeRecursive(this.model))
                            .then(response => {
                                this.showSaveNotification()
                                this.$emit('saved', response)
                            })
                            .catch(this.handleError)
                            .finally(() => this.unsetLoading())
                    }
                })
        },
    },
    mixins: [error, repository, stringCase],
    mounted() {
        this.load()
    },
    props: {
        id: {type: Number},
    },
}
</script>